<template>
  <!-- 하나 리본 배너 배경 — 남색–청록 그라데이션 위에 서로 묶이는 두 리본 선 -->
  <div class="ribbon-backdrop" aria-hidden="true">
    <svg viewBox="0 0 1200 280" preserveAspectRatio="none">
      <path
        d="M-40 210C180 210 210 60 420 60S660 210 600 140 540 70 780 70s240 150 460 150"
      />
      <path
        d="M-40 120C200 120 240 240 460 240s260-150 200-80-60 10 180 10 200-120 400-120"
      />
    </svg>
  </div>
</template>

<style scoped>
.ribbon-backdrop {
  position: absolute;
  inset: 0;
  background: linear-gradient(115deg, #07235e 0%, #0c3388 45%, #1b6f7e 100%);
}

.ribbon-backdrop svg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  fill: none;
  stroke: #fff;
  stroke-width: 1.5;
  opacity: 0.18;
}

.ribbon-backdrop path:last-child {
  opacity: 0.55;
}
</style>
